// @generated by scripts/api-contract/generate-api-family.mjs
// Template-Version: 1.0.0
// Source-Contract: packages/api-contract/src/coaching-resources-read.ts
// Family: coaching-resources-read
// DO NOT EDIT. Regenerate from the source contract descriptor.
import {
  coachingResourceDetailResponseSchema,
  coachingResourceListResponseSchema
} from '@vjal/api-contract'

export {
  coachingResourceDetailResponseSchema,
  coachingResourceListResponseSchema
} from '@vjal/api-contract'
export type {
  CoachingResourceDetailResponse,
  CoachingResourceListResponse
} from '@vjal/api-contract'

export const coachingResourcesReadPaths = {
  resourceList: '/resources',
  resourceDetail: '/resources/:resource_id',
} as const

export const coachingResourcesReadResponseSchemas = {
  resourceList: coachingResourceListResponseSchema,
  resourceDetail: coachingResourceDetailResponseSchema,
} as const

export type coachingResourcesReadOperation = 'resourceList' | 'resourceDetail'

export function coachingResourcesReadPath(
  operation: coachingResourcesReadOperation,
  params: Record<string, string | number> = {},
): string {
  return coachingResourcesReadPaths[operation].replace(/:([A-Za-z_][A-Za-z0-9_]*)/g, (_match, name: string) => {
    if (!(name in params)) throw new Error(`Missing route parameter: ${name}`)
    return encodeURIComponent(String(params[name]))
  })
}
